import http from "@/http/aisea/axios";
import qs from "qs";

const resource = "/enterprises/manning/vessels/crews";

export default {
  fetch(id) {
    return http.get(`${resource}/${id}/visits`, {
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  update(id, data) {
    return http.put(`${resource}/${id}/visits`, data, {
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  }
};